@if (!bankAccounts) {
  <div class="bank-connections-add-dialog-container">
    <!-- first step - select bank -->
    @if (!connection) {
      <app-banks (selected)="connection = $event"></app-banks>
    }
    <!-- second step - bank accounts add form for manual/basiq flow -->
    @if (connection?.isActive() || connection?.bank.isManual()) {
      <app-bank-accounts-add
        [connection]="connection"
        (saved)="dialogRef.close()"
        (back)="restart()"
        (connectionSaved)="connection = $event">
      </app-bank-accounts-add>
    }
  </div>
}
